import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { GestaoPCAPage } from './gestao-pca';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { JurisdicionadoService } from '../../../providers/jurisdicionado-service';
import { NgPipesModule } from 'ngx-pipes';
import { NgSelectModule } from "@ng-select/ng-select";

import { OrderModule } from 'ngx-order-pipe';
import { AssinaturaModule } from '../../../assinatura/assinatura.module';

@NgModule({
    declarations: [
        GestaoPCAPage
    ],
    imports: [
        IonicModule.forRoot(GestaoPCAPage),
        OrderModule,
        NgSelectModule,
        NgPipesModule,
        AssinaturaModule
    ],
    bootstrap: [
        IonicApp
    ],
    entryComponents: [
        GestaoPCAPage
    ],
    exports: [GestaoPCAPage],
    providers: [
        GestaoPcaService,
        JurisdicionadoService,
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ]
})
export class GestaoPCAModule {

}


// WEBPACK FOOTER //
// ./src/pages/modulos/gestao-pca/gestao-pca.module.ts